import { useCallback, useEffect, useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core'
import { getIncidence } from '../../api/orderIncidences.service'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { formatDate } from '../../common/utils'
import AcceptOrderIncidence from './AcceptOrderIncidence'
import { DialogTitle } from '../../components/DialogTitle'
import ResourceList from '../../components/Resources/ResourceList'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  }
}))

const IncidenceDetail = (props) => {
  const classes = useStyles()

  const incidenceCode = props.incidenceCode
  const handleClose = props.onClose

  const [loading, setLoading] = useState(false)
  const [stateForm, setStateForm] = useState({})
  const [isModalAcceptOpen, setIsModalAcceptOpen] = useState(false)

  const getData = useCallback(() => {
    setLoading(true)
    getIncidence(incidenceCode)
      .then((result) => {
        setStateForm(result.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [incidenceCode])

  useEffect(() => {
    if (incidenceCode !== undefined && incidenceCode !== null) {
      getData()
    }
  }, [incidenceCode, getData])

  const textEmpty = (text) => {
    if (text === undefined || text === null || text === '') {
      return '--'
    }
    return text
  }

  const Title = (_) => <h2>Incidencia: {incidenceCode}</h2>

  return (
    <div>
      <Grid container direction="column">
        <Grid item>
          <Grid container direction="row" spacing={2}>
            <DialogTitle title={<Title />} />
            <Grid item xs={12} md={6}>
              <Typography color="primary" variant="body1" className="text-uppercase">
                Información General:
              </Typography>
              <Divider className="mb-3" />
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Fecha de la incidencia
                  </Typography>
                  <Typography variant="body1">
                    {textEmpty(formatDate(stateForm.creationDate))}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Estado
                  </Typography>
                  <Typography variant="body1">{textEmpty(stateForm.state)}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Descripción
                  </Typography>
                  <Typography variant="body1">{textEmpty(stateForm.description)}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography color="primary" variant="body1" className="text-uppercase">
                Información Pedido:
              </Typography>
              <Divider className="mb-3" />
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Código pedido
                  </Typography>
                  <Typography variant="body1">
                    {textEmpty(stateForm.orderNumber) + '/' + textEmpty(stateForm.level)}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Fecha pedido
                  </Typography>
                  <Typography variant="body1">
                    {textEmpty(formatDate(stateForm.orderDate))}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Fecha de recepción
                  </Typography>
                  <Typography variant="body1">
                    {textEmpty(formatDate(stateForm.receptionDate))}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {stateForm.lineNumber && (
              <Grid item xs={12}>
                <Typography color="primary" variant="body1" className="text-uppercase">
                  Detalle:
                </Typography>
                <Divider className="mb-3" />
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12}>
                    <TableContainer component={Paper}>
                      <Table size="small" sx={{ minWidth: 300 }}>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              align="center"
                              width={'110px'}
                              className="font-weight-bold badge-secondary"
                            >
                              Cód. Producto
                            </TableCell>
                            <TableCell
                              align="center"
                              width={'110px'}
                              className="font-weight-bold badge-secondary"
                            >
                              Cód. Prod. Proveedor
                            </TableCell>
                            <TableCell
                              align="center"
                              width={'110px'}
                              className="font-weight-bold badge-secondary"
                            >
                              Descripción
                            </TableCell>
                            <TableCell
                              align="center"
                              width={'110px'}
                              className="font-weight-bold badge-secondary"
                            >
                              Pack
                            </TableCell>
                            <TableCell
                              align="center"
                              width={'110px'}
                              className="font-weight-bold badge-secondary"
                            >
                              Tamaño
                            </TableCell>
                            <TableCell
                              align="center"
                              width={'70px'}
                              className="font-weight-bold badge-secondary"
                            >
                              Cantidad Incidencia
                            </TableCell>
                            <TableCell
                              align="center"
                              width={'70px'}
                              className="font-weight-bold badge-secondary"
                            >
                              Cantidad Recibida
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell align="right">{stateForm.articleCode}</TableCell>
                            <TableCell align="right">{stateForm.providerArticleCode}</TableCell>
                            <TableCell align="right">{stateForm.articleDescription}</TableCell>
                            <TableCell align="right">{stateForm.articlePack}</TableCell>
                            <TableCell align="right">{stateForm.articleSize}</TableCell>
                            <TableCell align="right">{stateForm.incidenceQuantity}</TableCell>
                            <TableCell align="right">{stateForm.receivedQuantity}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
            )}

            <Grid item xs={12}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} className="pb-0">
                  <Typography color="primary" variant="body1">
                    ADJUNTOS:
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
                  <ResourceList resources={stateForm.documents} />
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
            </Grid>

            {handleClose !== undefined && (
              <SaveOrCancelButtons
                onSave={
                  !stateForm.isAccepted && stateForm.state !== 'Cerrada'
                    ? () => setIsModalAcceptOpen(true)
                    : undefined
                }
                saveLabel="Respuesta a la incidencia"
                onCancel={handleClose}
                cancelLabel="Cerrar"
                loading={loading}
              />
            )}

            <AcceptOrderIncidence
              open={isModalAcceptOpen}
              incidenceCode={incidenceCode}
              onCancel={() => setIsModalAcceptOpen(false)}
              onSave={
                handleClose
                  ? handleClose
                  : () => {
                      return
                    }
              }
            />
          </Grid>
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default IncidenceDetail
